module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"managedIcon":"Managed Point of Sale"},"es":{"managedIcon":"Restaurante gestionado"}}')
  delete Component.options._Ctor
}
